import { render, staticRenderFns } from "./CeremonyPresentationController.vue?vue&type=template&id=c8acd2b8&scoped=true"
import script from "./CeremonyPresentationController.vue?vue&type=script&setup=true&lang=js"
export * from "./CeremonyPresentationController.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CeremonyPresentationController.vue?vue&type=style&index=0&id=c8acd2b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8acd2b8",
  null
  
)

export default component.exports